import React from 'react';

export function useClickOutside(
  // Any click outside this element will be recognized as a click outside
  ref: React.MutableRefObject<HTMLElement | null>,
  // Callback function when a click outside is detected
  handler: (e: unknown) => void,
  // Element id that you may want to exclude from the click outside logic
  excludedElement?: string
) {
  React.useEffect(() => {
    const listener = (event: any) => {
      const excluded = document.getElementById(excludedElement || '') || undefined;

      // Do nothing if the clicked element is the excluded element
      if (excluded && excluded.contains(event.target)) {
        return;
      }

      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target) || excluded?.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, excludedElement]);
}

export default useClickOutside;
